export default __webpack_public_path__ + "static/media/gradient_bg_02.1fe56659.jpg";